import React from 'react';
import './DataTable.css';

const getWeatherIcon = (weather) => {
  switch (weather) {
    case 'sunny': return '☀️';
    case 'cloudy': return '☁️';
    case 'rainy': return '☂️';
    default: return '❓';
  }
};

const DataTable = ({ data }) => {
  const formatNumber = (num) => {
    if (typeof num !== 'number') return '–';
    return num.toFixed(1);
  };

  const headers = [
    '時刻', '天気', '気温[℃]', '日射量[kW/m²]', '降水量[mm]',
    '消費量予測[kWh]', '発電量予測[kWh]', '買電量[kWh]', '売電量[kWh]', 
    '蓄電量[kWh]', '放電量[kWh]'
  ];

  const dataKeys = [
    'time', 'weather', 'temperature', 'solarRadiation', 'precipitation',
    'consumption', 'generation', 'purchase', 'sale', 'storage', 'discharge'
  ];

  const formatCell = (row, key) => {
    const value = row[key];
    if (key === 'time') return value;
    if (key === 'weather') return getWeatherIcon(value);
    return formatNumber(value);
  };
  
  return (
    <div className="data-table">
      <div className="table-container">
        <table>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {dataKeys.map((key, cellIndex) => (
                  <td key={cellIndex} className={`${key}-cell`}>
                    {formatCell(row, key)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable; 